3
<template>
  <v-container>
    <v-row>
      <v-col class="col-12 col-md-8">
        <v-row>
          <v-col sm="12">
            <h2 class="text-h2">Údaje pro nájemní smlouvu</h2>
          </v-col>
        </v-row>

        <template v-if="loading">
          <v-row>
            <v-col sm="12">
              <v-skeleton-loader
                class="mx-auto"
                type="card"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </template>

        <template v-if="!loading">
          <v-row v-if="orderr == null">
            <v-col sm="12">
              <v-alert
                border="bottom"
                colored-border
                type="warning"
                elevation="2"
                class="my-5"
              >
                Nenašli jsme žádnou rozpracovanou rezervaci.
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="orderr == null">
            <v-col sm="12" md="8">
              <v-btn @click="goToRent" color="primary">
                Vytvořit novou rezervaci
              </v-btn>
            </v-col>
          </v-row>

          <template v-if="orderr != null">
            <!-- hlavni obsah -->
            <form ref="form">
              <v-row>
                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="name"
                    v-model="name"
                    :rules="[rules.required]"
                    label="Jméno *"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="surname"
                    v-model="surname"
                    :rules="[rules.required]"
                    label="Příjmení *"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="email"
                    v-model="email"
                    :rules="[rules.required, rules.email]"
                    label="E-mail *"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="phone"
                    v-model="phone"
                    :rules="[rules.required, rules.phone]"
                    label="Telefon *"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="street"
                    v-model="street"
                    :rules="[rules.required]"
                    label="Ulice a č.p. *"
                    required
                    dense
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="city"
                    v-model="city"
                    :rules="[rules.required]"
                    label="Město *"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="postalCode"
                    v-model="postalCode"
                    :rules="[rules.required]"
                    label="PSČ *"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>

                <v-col class="col-12 col-sm-6">
                  <v-autocomplete
                    ref="country"
                    v-model="country"
                    :rules="[() => !!country || 'Země je povinná položka']"
                    :items="countries"
                    item-text="name"
                    item-value="code"
                    label="Země *"
                    placeholder="Vyberte..."
                    required
                    dense
                    outlined
                  ></v-autocomplete>
                </v-col>

                <v-col class="col-12">
                  <v-text-field
                    ref="companyName"
                    v-model="companyName"
                    label="Název firmy"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="ic"
                    v-model="ic"
                    label="IČ"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col class="col-12 col-sm-6">
                  <v-text-field
                    ref="dic"
                    v-model="dic"
                    label="DIČ"
                    outlined
                    dense
                    required
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row v-if="!formHasErrors">
                <v-col sm="12" md="12">
                  <v-alert class="warning">
                    Vyplňte potřebné údaje pro nájemní smlouvu
                  </v-alert>
                </v-col>
              </v-row>

              <v-row v-if="mobConfig.checkoutStaticInfo">
                <v-col sm="12">
                  <v-alert
                    border="top"
                    outlined
                    type="info"
                    elevation="1"
                    class="my-5"
                    v-html="mobConfig.checkoutStaticInfo"
                  ></v-alert>
                </v-col>
              </v-row>
            </form>
          </template>
        </template>
      </v-col>

      <v-col class="col-12 col-md-4">
        <!-- souhrn objednavky -->
        <v-card v-if="!loading && orderr != null">
          <v-card-title> Přehled objednávky </v-card-title>

          <v-card-text>
            <orderr-summary
              v-bind:orderr="orderr"
              showExpirationTime
              showStatus
              showPaymentMethod
              showDatePickUp
              showPointSell
              showRentalPeriod
              showPrice
            ></orderr-summary>
          </v-card-text>

          <v-card-actions class="pt-0">
            <v-btn
              block
              color="success accent-4"
              :loading="submiting"
              :disabled="currentOrderrExpired"
              @click="placeOrderr"
            >
              Odeslat objednávku
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrderrSummary from "@/components/OrderrSummary";
import PhoneNumber from "awesome-phonenumber";

export default {
  metaInfo: {
    title: "Objednání - Údaje pro nájemní smlouvu",
  },

  components: {
    OrderrSummary,
  },

  data: () => ({
    name: "",
    surname: "",
    companyName: "",
    street: "",
    city: "",
    postalCode: "",
    country: "CZ",
    email: "",
    phone: "",
    phoneNumber: null,
    documentType: "",
    documentNumber: "",
    documentTypeItems: ["Občanský průkaz", "Pas", "Povolení k pobytu"],
    description: "",
    ic: "",
    dic: "",

    yourValue: null,

    errorMessages: [],
    formHasErrors: false,
    loading: false,
    submiting: false,

    rules: {
      required: (value) => !!value || "Povinná položka.",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Zadejte platnou e-mailovou adresu.";
      },
      phone: (value) => {
        let pn = new PhoneNumber(value);
        return (
          pn.isValid(value) ||
          "Zadejte číslo v mezinároním formátu, např. +420 601 123 456."
        );
      },
    },

    translations: {
      countrySelectorLabel: "Předvolba",
      countrySelectorError: "Vyberte zemi",
      phoneNumberLabel: "Telefonní číslo",
      example: "Příklad :",
    },

    countries: [
      { code: "AF", name: "Afghanistan" },
      { code: "AL", name: "Albania" },
      { code: "DZ", name: "Algeria" },
      { code: "AS", name: "American Samoa" },
      { code: "AD", name: "Andorra" },
      { code: "AO", name: "Angola" },
      { code: "AI", name: "Anguilla" },
      { code: "AQ", name: "Antarctica" },
      { code: "AG", name: "Antigua and Barbuda" },
      { code: "AR", name: "Argentina" },
      { code: "AM", name: "Armenia" },
      { code: "AW", name: "Aruba" },
      { code: "AU", name: "Australia" },
      { code: "AT", name: "Austria" },
      { code: "AZ", name: "Azerbaijan" },
      { code: "BS", name: "Bahamas" },
      { code: "BH", name: "Bahrain" },
      { code: "BD", name: "Bangladesh" },
      { code: "BB", name: "Barbados" },
      { code: "BY", name: "Belarus" },
      { code: "BE", name: "Belgium" },
      { code: "BZ", name: "Belize" },
      { code: "BJ", name: "Benin" },
      { code: "BM", name: "Bermuda" },
      { code: "BT", name: "Bhutan" },
      { code: "BO", name: "Bolivia" },
      { code: "BA", name: "Bosnia and Herzegovina" },
      { code: "BW", name: "Botswana" },
      { code: "BR", name: "Brazil" },
      { code: "IO", name: "British Indian Ocean Territory" },
      { code: "VG", name: "British Virgin Islands" },
      { code: "BN", name: "Brunei" },
      { code: "BG", name: "Bulgaria" },
      { code: "BF", name: "Burkina Faso" },
      { code: "BI", name: "Burundi" },
      { code: "KH", name: "Cambodia" },
      { code: "CM", name: "Cameroon" },
      { code: "CA", name: "Canada" },
      { code: "CV", name: "Cape Verde" },
      { code: "KY", name: "Cayman Islands" },
      { code: "CF", name: "Central African Republic" },
      { code: "TD", name: "Chad" },
      { code: "CL", name: "Chile" },
      { code: "CN", name: "China" },
      { code: "CX", name: "Christmas Island" },
      { code: "CC", name: "Cocos Islands" },
      { code: "CO", name: "Colombia" },
      { code: "KM", name: "Comoros" },
      { code: "CK", name: "Cook Islands" },
      { code: "CR", name: "Costa Rica" },
      { code: "HR", name: "Croatia" },
      { code: "CU", name: "Cuba" },
      { code: "CW", name: "Curacao" },
      { code: "CY", name: "Cyprus" },
      { code: "CZ", name: "Česká republika" }, //Czech Republic
      { code: "CD", name: "Democratic Republic of the Congo" },
      { code: "DK", name: "Denmark" },
      { code: "DJ", name: "Djibouti" },
      { code: "DM", name: "Dominica" },
      { code: "DO", name: "Dominican Republic" },
      { code: "TL", name: "East Timor" },
      { code: "EC", name: "Ecuador" },
      { code: "EG", name: "Egypt" },
      { code: "SV", name: "El Salvador" },
      { code: "GQ", name: "Equatorial Guinea" },
      { code: "ER", name: "Eritrea" },
      { code: "EE", name: "Estonia" },
      { code: "ET", name: "Ethiopia" },
      { code: "FK", name: "Falkland Islands" },
      { code: "FO", name: "Faroe Islands" },
      { code: "FJ", name: "Fiji" },
      { code: "FI", name: "Finland" },
      { code: "FR", name: "France" },
      { code: "PF", name: "French Polynesia" },
      { code: "GA", name: "Gabon" },
      { code: "GM", name: "Gambia" },
      { code: "GE", name: "Georgia" },
      { code: "DE", name: "Germany" },
      { code: "GH", name: "Ghana" },
      { code: "GI", name: "Gibraltar" },
      { code: "GR", name: "Greece" },
      { code: "GL", name: "Greenland" },
      { code: "GD", name: "Grenada" },
      { code: "GU", name: "Guam" },
      { code: "GT", name: "Guatemala" },
      { code: "GG", name: "Guernsey" },
      { code: "GN", name: "Guinea" },
      { code: "GW", name: "Guinea-Bissau" },
      { code: "GY", name: "Guyana" },
      { code: "HT", name: "Haiti" },
      { code: "HN", name: "Honduras" },
      { code: "HK", name: "Hong Kong" },
      { code: "HU", name: "Hungary" },
      { code: "IS", name: "Iceland" },
      { code: "IN", name: "India" },
      { code: "ID", name: "Indonesia" },
      { code: "IR", name: "Iran" },
      { code: "IQ", name: "Iraq" },
      { code: "IE", name: "Ireland" },
      { code: "IM", name: "Isle of Man" },
      { code: "IL", name: "Israel" },
      { code: "IT", name: "Italy" },
      { code: "CI", name: "Ivory Coast" },
      { code: "JM", name: "Jamaica" },
      { code: "JP", name: "Japan" },
      { code: "JE", name: "Jersey" },
      { code: "JO", name: "Jordan" },
      { code: "KZ", name: "Kazakhstan" },
      { code: "KE", name: "Kenya" },
      { code: "KI", name: "Kiribati" },
      { code: "XK", name: "Kosovo" },
      { code: "KW", name: "Kuwait" },
      { code: "KG", name: "Kyrgyzstan" },
      { code: "LA", name: "Laos" },
      { code: "LV", name: "Latvia" },
      { code: "LB", name: "Lebanon" },
      { code: "LS", name: "Lesotho" },
      { code: "LR", name: "Liberia" },
      { code: "LY", name: "Libya" },
      { code: "LI", name: "Liechtenstein" },
      { code: "LT", name: "Lithuania" },
      { code: "LU", name: "Luxembourg" },
      { code: "MO", name: "Macau" },
      { code: "MK", name: "Macedonia" },
      { code: "MG", name: "Madagascar" },
      { code: "MW", name: "Malawi" },
      { code: "MY", name: "Malaysia" },
      { code: "MV", name: "Maldives" },
      { code: "ML", name: "Mali" },
      { code: "MT", name: "Malta" },
      { code: "MH", name: "Marshall Islands" },
      { code: "MR", name: "Mauritania" },
      { code: "MU", name: "Mauritius" },
      { code: "YT", name: "Mayotte" },
      { code: "MX", name: "Mexico" },
      { code: "FM", name: "Micronesia" },
      { code: "MD", name: "Moldova" },
      { code: "MC", name: "Monaco" },
      { code: "MN", name: "Mongolia" },
      { code: "ME", name: "Montenegro" },
      { code: "MS", name: "Montserrat" },
      { code: "MA", name: "Morocco" },
      { code: "MZ", name: "Mozambique" },
      { code: "MM", name: "Myanmar" },
      { code: "NA", name: "Namibia" },
      { code: "NR", name: "Nauru" },
      { code: "NP", name: "Nepal" },
      { code: "NL", name: "Netherlands" },
      { code: "AN", name: "Netherlands Antilles" },
      { code: "NC", name: "New Caledonia" },
      { code: "NZ", name: "New Zealand" },
      { code: "NI", name: "Nicaragua" },
      { code: "NE", name: "Niger" },
      { code: "NG", name: "Nigeria" },
      { code: "NU", name: "Niue" },
      { code: "KP", name: "North Korea" },
      { code: "MP", name: "Northern Mariana Islands" },
      { code: "NO", name: "Norway" },
      { code: "OM", name: "Oman" },
      { code: "PK", name: "Pakistan" },
      { code: "PW", name: "Palau" },
      { code: "PS", name: "Palestine" },
      { code: "PA", name: "Panama" },
      { code: "PG", name: "Papua New Guinea" },
      { code: "PY", name: "Paraguay" },
      { code: "PE", name: "Peru" },
      { code: "PH", name: "Philippines" },
      { code: "PN", name: "Pitcairn" },
      { code: "PL", name: "Poland" },
      { code: "PT", name: "Portugal" },
      { code: "PR", name: "Puerto Rico" },
      { code: "QA", name: "Qatar" },
      { code: "CG", name: "Republic of the Congo" },
      { code: "RE", name: "Reunion" },
      { code: "RO", name: "Romania" },
      { code: "RU", name: "Russia" },
      { code: "RW", name: "Rwanda" },
      { code: "BL", name: "Saint Barthelemy" },
      { code: "SH", name: "Saint Helena" },
      { code: "KN", name: "Saint Kitts and Nevis" },
      { code: "LC", name: "Saint Lucia" },
      { code: "MF", name: "Saint Martin" },
      { code: "PM", name: "Saint Pierre and Miquelon" },
      { code: "VC", name: "Saint Vincent and the Grenadines" },
      { code: "WS", name: "Samoa" },
      { code: "SM", name: "San Marino" },
      { code: "ST", name: "Sao Tome and Principe" },
      { code: "SA", name: "Saudi Arabia" },
      { code: "SN", name: "Senegal" },
      { code: "RS", name: "Serbia" },
      { code: "SC", name: "Seychelles" },
      { code: "SL", name: "Sierra Leone" },
      { code: "SG", name: "Singapore" },
      { code: "SX", name: "Sint Maarten" },
      { code: "SK", name: "Slovakia" },
      { code: "SI", name: "Slovenia" },
      { code: "SB", name: "Solomon Islands" },
      { code: "SO", name: "Somalia" },
      { code: "ZA", name: "South Africa" },
      { code: "KR", name: "South Korea" },
      { code: "SS", name: "South Sudan" },
      { code: "ES", name: "Spain" },
      { code: "LK", name: "Sri Lanka" },
      { code: "SD", name: "Sudan" },
      { code: "SR", name: "Suriname" },
      { code: "SJ", name: "Svalbard and Jan Mayen" },
      { code: "SZ", name: "Swaziland" },
      { code: "SE", name: "Sweden" },
      { code: "CH", name: "Switzerland" },
      { code: "SY", name: "Syria" },
      { code: "TW", name: "Taiwan" },
      { code: "TJ", name: "Tajikistan" },
      { code: "TZ", name: "Tanzania" },
      { code: "TH", name: "Thailand" },
      { code: "TG", name: "Togo" },
      { code: "TK", name: "Tokelau" },
      { code: "TO", name: "Tonga" },
      { code: "TT", name: "Trinidad and Tobago" },
      { code: "TN", name: "Tunisia" },
      { code: "TR", name: "Turkey" },
      { code: "TM", name: "Turkmenistan" },
      { code: "TC", name: "Turks and Caicos Islands" },
      { code: "TV", name: "Tuvalu" },
      { code: "VI", name: "U.S. Virgin Islands" },
      { code: "UG", name: "Uganda" },
      { code: "UA", name: "Ukraine" },
      { code: "AE", name: "United Arab Emirates" },
      { code: "GB", name: "United Kingdom" },
      { code: "US", name: "United States" },
      { code: "UY", name: "Uruguay" },
      { code: "UZ", name: "Uzbekistan" },
      { code: "VU", name: "Vanuatu" },
      { code: "VA", name: "Vatican" },
      { code: "VE", name: "Venezuela" },
      { code: "VN", name: "Vietnam" },
      { code: "WF", name: "Wallis and Futuna" },
      { code: "EH", name: "Western Sahara" },
      { code: "YE", name: "Yemen" },
      { code: "ZM", name: "Zambia" },
      { code: "ZW", name: "Zimbabwe" },
    ],
  }),

  async mounted() {
    console.log("mounted -- checkout-contacts");
    // nastavit stav, ze se nacita
    this.loading = true;

    // zkontrolovat, ze je uzivatel prihlaseny a dalsi nutne prerekvizity
    if (
      this.$store.state.user == null ||
      this.$store.state.appInstance == null
    ) {
      console.log("Nesplnene prerekvizity user nebo app instance jsou null");
      this.$router.push({ name: "rent" });
    }

    // nacist aktualni objednavku s polozkami
    await this.$store.dispatch("loadCurrentOrderrDRAFT");

    // predvyplnit jmeno, prijmeni, email
    if (
      this.$store.state.user != null &&
      this.$store.state.user.attributes != undefined
    ) {
      if (this.$store.state.user.attributes.email != undefined) {
        this.email = this.$store.state.user.attributes.email;
      }
      if (this.$store.state.user.attributes.name != undefined) {
        this.name = this.$store.state.user.attributes.name;
      }
      if (this.$store.state.user.attributes.family_name != undefined) {
        this.surname = this.$store.state.user.attributes.family_name;
      }
    }

    // dokoncit nacitani - zmena stavu
    this.loading = false;
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    form() {
      return {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        street: this.street,
        city: this.city,
        postalCode: this.postalCode,
        country: this.country,
        ic: this.ic,
        dic: this.dic,
        companyName: this.companyName,
      };
    },

    orderr() {
      return this.$store.state.currentOrderr;
    },
    currentOrderrExpired() {
      return this.$store.state.currentOrderrExpired;
    },
  },

  methods: {
    onPhoneUpdate(payload) {
      console.log(payload);
      this.phoneNumber = payload;
    },

    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].reset();
      });
    },

    validateForm() {
      this.formHasErrors = false;

      console.log("validateForm");
      Object.keys(this.form).forEach((f) => {
        console.log(f);
        if (!this.form[f]) {
          this.formHasErrors = true;
          console.log("!this.form[f]");
        }
        console.log(this.$refs[f]);
        this.$refs[f].validate(true);
      });
    },

    async onContactFormChange(payload) {
      this.contactData = payload;
    },

    goToRent() {
      this.$router.push({ name: "rent" });
    },

    async placeOrderr() {
      console.log("placeOrder");
      this.validateForm();

      if (this.formHasErrors) {
        return;
      }

      this.submiting = true;

      try {
        let contactData = {
          ...this.form,
          documentNumber: this.documentNumber,
          documentType: this.documentType,
        };

        let payload = {
          orderrId: this.orderr.id,
          contactData,
        };
        console.log("CheckoutContacts - checkoutOrderr");
        await this.$store.dispatch("checkoutOrderr", payload);
        console.log("CheckoutContacts - getOrderr");
        await this.$store.dispatch("getOrderr", this.orderr.id);
        console.log("CheckoutContacts - getOrderr: ");
        console.log(this.orderr);

        console.log("CheckoutContacts - redirect ");

        let paymentToPay = null;
        if (this.orderr.payments.items.length > 0) {
          for (let i = 0; i < this.orderr.payments.items.length; i++) {
            let payment = this.orderr.payments.items[i];
            if (
              payment.paymentMethod == "CARD_ONLINE" &&
              payment.paymentState == "PENDING"
            ) {
              paymentToPay = payment;
              break;
            }
          }
        }

        console.log("paymentToPay");
        console.log(paymentToPay);

        if (paymentToPay != null) {
          window.location.href = paymentToPay.redirectUrl;
        } else {
          this.$router.push({
            name: "checkout-completed",
            params: { orderrId: this.orderr.id },
          });
        }

        // budete presmerovani na platebni branu - zobrazit popup
        // switch (this.orderr.bookingState) {
        //   case "CHECKOUT":
        //     //this.$router.push({ name: "checkout-payment", params: { paymentId: payment.id } });
        //     break;
        //   case "RESERVATION":
        //     this.$router.push({
        //       name: "checkout-completed",
        //       params: { orderrId: this.orderr.id },
        //     });
        //     break;
        //   default:
        //     this.$router.push({ name: "rent" });
        //     // TODO: vyhodit nejakou chybovou hlasku
        //     break;
        // }
      } catch (error) {
        console.log(error);
      }

      this.submiting = false;
    },
  },
};
</script>
